import moment from 'moment';
import { DATE_TIME_FORMAT } from '@utils/constants';
import { humanize } from '@utils';
import getTimeInHMSFormat from '@utils/getTimeInHMSFormat';

const formatDate = (data) => {
  if (moment(data).isValid()) {
    return moment(data).format(DATE_TIME_FORMAT);
  }
  return '-';
};

const isNumeric = (num) => {
  return !isNaN(num);
};

const formatMetricPct = (data) => {
  return `${data} %`;
};

const formatBitrate = (data) => {
  return humanize(data, 'bps') + 'bps';
};

const formatKbps = (value: any) => {
  if (isNumeric(value)) {
    let unit = 'bps';
    const [bpsValue, bpsUnit] = humanize(value * 1000, unit).split(' ');
    unit = `${bpsUnit || ''}${unit || ''}`;
    return `${bpsValue} ${unit}`;
  } else {
    return '-';
  }
};

const formatMilliSecs = (data) => {
  if (isNumeric(data)) {
    if (data < 0) {
      return `${data}s`;
    }
    const milliseconds = Number(data);
    let seconds = Math.floor(milliseconds / 1000);
    let minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    seconds = seconds % 60;
    minutes = minutes % 60;
    return getTimeInHMSFormat(hours, minutes, seconds);
  } else {
    return '-';
  }
};

const formatSecs = (data) => {
  if (isNumeric(data)) {
    let seconds = Number(data);
    let minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    seconds = seconds % 60;
    minutes = minutes % 60;
    return getTimeInHMSFormat(hours, minutes, seconds);
  } else {
    return '-';
  }
};

const formatMStoSecs = (data) => {
  const milliseconds = Number(data);
  let seconds = milliseconds / 1000;
  seconds = seconds % 60;
  const displayText = `${Number(seconds).toFixed(2)} s`;
  return displayText;
};

const formatDatatoSecs = (data) => {
  if (isNumeric(data)) {
    return `${Number(data).toFixed(2)} s`;
  } else {
    return '-';
  }
};

export {
  formatDate,
  formatMetricPct,
  formatBitrate,
  formatMilliSecs,
  formatSecs,
  formatMStoSecs,
  formatDatatoSecs,
  formatKbps,
};
